export class OrderAmounts {
   constructor(subtotal, ieps, iva, tax, after_tax_total, discount, final_total){
      this.subtotal = subtotal
      this.ieps = ieps
      this.iva = iva
      this.tax = tax
      this.after_tax_total = after_tax_total,
      this.discount = discount
      this.final_total = final_total
   }
}